// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-61f011e7] .el-input-number {\n  margin-left: 20px;\n}\n.tips[data-v-61f011e7]::before {\n  content: '*';\n  color: red;\n  display: inline-block;\n  padding-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
